/**
 * Settings vocabulary (`/settings/:tab`: account, workspaces, language,
 * notifications) and the create-workspace modal. Assembled into
 * `WorkspaceCopy` by `../copy.ts`.
 */

export const settingsCopyEn = {
  settings: {
    title: 'Settings',
    sections: 'Settings sections',
    account: 'Account',
    workspaces: 'Workspaces',
    language: 'Language',
    notifications: 'Notifications',
    name: 'Name',
    email: 'Email',
    signedInWith: 'Signed in with',
    google: 'Google',
    editName: 'Edit name',
    editNameSoon: 'Editing your name is not available yet.',
    signOut: 'Sign out',
    currentWs: 'Current',
    switch: 'Switch',
    createWs: 'Create New Workspace',
    createWsSoon:
      'Mouja supports one workspace per account today. More workspaces are coming.',
    interfaceLanguage: 'Interface language',
    english: 'English',
    arabic: 'العربية',
    languageNote:
      'Arabic switches the workspace to a right-to-left layout. The language of each video is chosen per Production Line.',
    notifReady: 'A video is ready',
    notifReadyBody: 'Email me when a Production Line finishes a video.',
    notifInput: 'A Production Line needs my input',
    notifInputBody: 'Email me when Mouja is waiting on a decision.',
    notifWeekly: 'Weekly summary',
    notifWeeklyBody:
      'One email every Sunday with what happened across your workspaces.',
    notifSoon:
      'Notification preferences are not available yet. Mouja emails you when a video is ready.',
  },
  workspaceModal: {
    title: 'Create New Workspace',
    body: 'A workspace represents one business or brand, with its own Business Profile and Production Lines.',
    name: 'Business name',
    namePlaceholder: 'e.g. Riyadh Specialty Coffee',
    website: 'Website',
    submit: 'Create Workspace',
    soon: 'Mouja supports one workspace per account today. Creating another is coming soon.',
  },
};

export const settingsCopyAr: typeof settingsCopyEn = {
  settings: {
    title: 'الإعدادات',
    sections: 'أقسام الإعدادات',
    account: 'الحساب',
    workspaces: 'مساحات العمل',
    language: 'اللغة',
    notifications: 'الإشعارات',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    signedInWith: 'مسجّل دخولك عبر',
    google: 'Google',
    editName: 'تعديل الاسم',
    editNameSoon: 'تعديل الاسم مو متاح لين الحين.',
    signOut: 'تسجيل الخروج',
    currentWs: 'الحالية',
    switch: 'بدّل',
    createWs: 'ضيف مساحة عمل جديدة',
    createWsSoon: 'موجة تدعم مساحة عمل وحدة لكل حساب الحين. ومساحات إضافية جايه.',
    interfaceLanguage: 'لغة الواجهة',
    english: 'English',
    arabic: 'العربية',
    languageNote:
      'العربية تحوّل مساحة العمل لتخطيط من اليمين لليسار. ولغة كل فيديو تختارها في خط الإنتاج نفسه.',
    notifReady: 'فيديو جاهز',
    notifReadyBody: 'راسلني بالإيميل لما يخلص خط إنتاج فيديو.',
    notifInput: 'خط إنتاج يحتاج شي مني',
    notifInputBody: 'راسلني بالإيميل لما تنتظر موجة قرار مني.',
    notifWeekly: 'ملخص أسبوعي',
    notifWeeklyBody: 'إيميل واحد كل أحد باللي صار في مساحات عملك.',
    notifSoon:
      'تفضيلات الإشعارات مو متاحة لين الحين. موجة ترسل لك إيميل أول ما يجهز فيديو.',
  },
  workspaceModal: {
    title: 'ضيف مساحة عمل جديدة',
    body: 'كل مساحة عمل تمثّل نشاط أو علامة تجارية وحدة، ولها ملف تجاري وخطوط إنتاج خاصة فيها.',
    name: 'اسم النشاط',
    namePlaceholder: 'مثال: قهوة الرياض المختصة',
    website: 'الموقع',
    submit: 'ضيف مساحة العمل',
    soon: 'موجة تدعم مساحة عمل وحدة لكل حساب الحين. وإضافة مساحة ثانية جايه قريب.',
  },
};
